// src/home/Header.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import baseURL from '../config';

const Header = () => {
  const [headerData, setHeaderData] = useState(null);

  useEffect(() => {
    fetch(`${baseURL}/api/index/`)
      .then((res) => res.json())
      .then((data) => setHeaderData(data))
      .catch((err) => console.error("Error:", err));
  }, []);

  if (!headerData) return <div>Loading...</div>;

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary border-bottom">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={headerData.header.logo} alt="Logo" height="50" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            {headerData.header.menu.map((item, index) => (
              <li className="nav-item" key={index}>
                <Link className="nav-link fw-medium" to={item.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
